import type { ReactElement, ReactNode, ChangeEvent } from 'react';
import { Component as CheckIcon } from 'icons/icon-ui--check.svg';

type Props = {
  id: string;
  label: ReactNode;
  ariaLabel?: string;
  name: string;
  checked?: boolean;
  disabled?: boolean;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
};

function RadioButton({
  id,
  label,
  ariaLabel,
  name,
  checked,
  disabled,
  onChange,
}: Props): ReactElement {
  return (
    <div className="c-input-radio">
      <label htmlFor={id}>
        {label}
        <input
          id={id}
          type="radio"
          name={name}
          checked={checked}
          disabled={disabled}
          aria-label={ariaLabel}
          onChange={onChange}
        />
        <span className="c-input-custom">
          <CheckIcon
            width="13"
            height="13"
            className="c-input-custom__icon c-svg-fill-white-color"
          />
        </span>
      </label>
    </div>
  );
}

export default RadioButton;
